// Tile SVG bodies extracted by hand from
// docs/ghost-works/truchet-tiles-source/tile1.svg and tile2.svg (also
// ~/Documents/KEP/website/src/assets/truchet-tiles/tile1.svg / tile2.svg —
// see that folder's README for provenance and re-extraction steps). The
// outer <svg> declares viewBox="0 0 400 400", re-exported specifically so
// the artwork's own designed tile boundary (a hidden fill:none "Frame"
// rect embedded in each tile) matches that viewBox exactly — verified via
// the regression test in truchet-tiles-data.test.js, which recomputes the
// Frame rect's true size from the matrices below and confirms it lands
// within noise of 400 x 400 for both tiles independently. (An earlier
// export had a ~0.6-unit mismatch between the declared viewBox and the
// artwork's true frame, which scaled every tile very slightly undersized
// and left a visible gap at every internal tile grid boundary — fixed by
// this re-export, not by a code-side correction.)
// Any id="..." attribute is stripped from the body (tile2's outer <g> had
// id="Frame"; tile1's is unlabeled), matching the Astro page's
// extractTile() so multiple tile instances on one page never collide on id.

const tile1Body = `
    <g transform="matrix(0.845411,0,0,0.845411,0,0)">
        <g transform="matrix(0,-0.505569,0.505569,0,-429.494444,868.258449)">
            <rect x="781.526" y="849.525" width="935.861" height="935.861" style="fill:none;"/>
        </g>
        <g transform="matrix(0,-0.435791,0.404256,0,-416.127706,1001.834226)">
            <path d="M1413.474,1029.365L1555.737,1029.365C1555.737,1233.177 1402.241,1398.646 1213.178,1398.646L1213.178,1245.286C1323.724,1245.286 1413.474,1148.535 1413.474,1029.365Z"/>
        </g>
        <g transform="matrix(0,-0.871582,0.808513,0,-832.255256,1530.525651)">
            <path d="M1449.04,1029.365L1520.171,1029.365C1520.171,1212.017 1382.612,1360.306 1213.178,1360.306L1213.178,1283.626C1343.353,1283.626 1449.04,1169.696 1449.04,1029.365Z"/>
        </g>
        <g transform="matrix(0,0.435791,-0.404256,0,889.270563,-528.691795)">
            <path d="M1413.474,1029.365L1555.737,1029.365C1555.737,1233.177 1402.241,1398.646 1213.178,1398.646L1213.178,1245.286C1323.724,1245.286 1413.474,1148.535 1413.474,1029.365Z"/>
        </g>
        <g transform="matrix(0,0.871582,-0.808513,0,1305.398114,-1057.38322)">
            <path d="M1449.04,1029.365L1520.171,1029.365C1520.171,1212.017 1382.612,1360.306 1213.178,1360.306L1213.178,1283.626C1343.353,1283.626 1449.04,1169.696 1449.04,1029.365Z"/>
        </g>
        <g transform="matrix(0,1.307372,-1.212769,0,1721.525664,-1586.074646)">
            <path d="M1440.11,1136.532C1453.475,1103.722 1460.895,1067.471 1460.895,1029.365L1508.316,1029.365C1508.316,1058.039 1504.79,1085.831 1498.18,1112.266C1477.876,1118.166 1458.436,1126.345 1440.11,1136.532Z"/>
        </g>
        <g transform="matrix(0,1.307372,-1.212769,0,1721.525664,-1586.074646)">
            <path d="M1290.079,1336.6C1265.557,1343.725 1239.776,1347.526 1213.178,1347.526L1213.178,1296.406C1248.525,1296.406 1282.154,1288.408 1312.589,1274C1303.139,1293.755 1295.552,1314.712 1290.079,1336.6Z"/>
        </g>
        <g transform="matrix(0,-1.307372,1.212769,0,-1248.382807,2059.217077)">
            <path d="M1460.895,1029.365L1508.316,1029.365C1508.316,1204.963 1376.069,1347.526 1213.178,1347.526L1213.178,1296.406C1349.897,1296.406 1460.895,1176.749 1460.895,1029.365Z"/>
        </g>
    </g>
`.trim();

const tile2Body = `
    <g transform="matrix(0.845411,0,0,0.845411,0,0)">
        <g transform="matrix(0.505568,0,0,0.505568,-395.113815,-429.492345)">
            <rect x="781.526" y="849.525" width="935.861" height="935.861" style="fill:none;"/>
        </g>
        <g transform="matrix(0.871579,0,0,0.80851,-1057.37893,-832.251889)">
            <path d="M1449.04,1029.365L1520.171,1029.365C1520.171,1212.017 1382.612,1360.306 1213.178,1360.306L1213.178,1283.626C1343.353,1283.626 1449.04,1169.696 1449.04,1029.365Z"/>
        </g>
        <g transform="matrix(-0.871579,0,0,-0.80851,1530.521787,1305.394746)">
            <path d="M1449.04,1029.365L1520.171,1029.365C1520.171,1212.017 1382.612,1360.306 1213.178,1360.306L1213.178,1283.626C1343.353,1283.626 1449.04,1169.696 1449.04,1029.365Z"/>
        </g>
        <g transform="matrix(0.435789,0,0,0.404255,-528.689171,-416.12565)">
            <path d="M1413.474,1029.365L1555.737,1029.365C1555.737,1233.177 1402.241,1398.646 1213.178,1398.646L1213.178,1245.286C1323.724,1245.286 1413.474,1148.535 1413.474,1029.365Z"/>
        </g>
        <g transform="matrix(0,0.435789,-0.404255,0,889.268507,-528.689171)">
            <path d="M1413.474,1029.365L1555.737,1029.365C1555.737,1233.177 1402.241,1398.646 1213.178,1398.646L1213.178,1245.286C1323.724,1245.286 1413.474,1148.535 1413.474,1029.365Z"/>
        </g>
        <g transform="matrix(-0.435789,0,0,-0.404255,1001.832028,889.268507)">
            <path d="M1413.474,1029.365L1555.737,1029.365C1555.737,1233.177 1402.241,1398.646 1213.178,1398.646L1213.178,1245.286C1323.724,1245.286 1413.474,1148.535 1413.474,1029.365Z"/>
        </g>
        <g transform="matrix(0,-0.435789,0.404255,0,-416.12565,1001.832028)">
            <path d="M1413.474,1029.365L1555.737,1029.365C1555.737,1233.177 1402.241,1398.646 1213.178,1398.646L1213.178,1245.286C1323.724,1245.286 1413.474,1148.535 1413.474,1029.365Z"/>
        </g>
    </g>
`.trim();

export const tiles = {
    tile1: { body: tile1Body, w: 400, h: 400 },
    tile2: { body: tile2Body, w: 400, h: 400 },
};
